import { useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { User, Lock, Eye, EyeOff } from "lucide-react";
import { OrganizationContext } from "../clients/utils/OrganizationContext";
import OrgAuthShell, { Champ, BoutonPrincipal } from "./OrgAuthShell";

const API = "https://api.komorotel.com/api";

export default function OrganizationLogin() {
  const navigate = useNavigate();
  const { refetch } = useContext(OrganizationContext);
  const [form, setForm]       = useState({ email: "", password: "" });
  const [voirMdp, setVoirMdp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [erreur, setErreur]   = useState(null);

  const envoyer = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErreur(null);
    try {
      await axios.post(`${API}/organization/login`, form, { withCredentials: true });
      await refetch();
      navigate("/organisation");
    } catch (err) {
      setErreur(err.response?.data?.message || "Identifiants incorrects.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <OrgAuthShell
      titre="Espace organisation"
      sousTitre="Connectez-vous pour gérer vos membres et vos séjours."
      pied={
        <>
          Votre organisation n'a pas encore de compte ?{" "}
          <a href="/organisation/demande" className="font-semibold text-[var(--k-green)] hover:underline">
            Faire une demande
          </a>
        </>
      }
    >
      <form onSubmit={envoyer} className="flex flex-col gap-5">
        {erreur && (
          <p className="px-3.5 py-2.5 rounded-xl bg-red-50 border border-red-100 text-sm text-red-600">
            {erreur}
          </p>
        )}

        <Champ
          label="Email"
          type="email"
          value={form.email}
          required
          icone={<User size={17} strokeWidth={1.75} />}
          onChange={v => { setForm(f => ({ ...f, email: v })); setErreur(null); }}
        />

        <Champ
          label="Mot de passe"
          type={voirMdp ? "text" : "password"}
          value={form.password}
          required
          onChange={v => { setForm(f => ({ ...f, password: v })); setErreur(null); }}
          icone={<Lock size={17} strokeWidth={1.75} />}
          droite={
            <button
              type="button"
              onClick={() => setVoirMdp(v => !v)}
              aria-label={voirMdp ? "Masquer le mot de passe" : "Afficher le mot de passe"}
              className="text-gray-400 hover:text-gray-600 transition"
            >
              {voirMdp ? <EyeOff size={17} strokeWidth={1.75} /> : <Eye size={17} strokeWidth={1.75} />}
            </button>
          }
        />

        <BoutonPrincipal type="submit" disabled={loading}>
          {loading ? "Connexion..." : "Se connecter"}
        </BoutonPrincipal>
      </form>
    </OrgAuthShell>
  );
}
